import { render, staticRenderFns } from "./LightTheme.vue?vue&type=template&id=5c4cdc54&"
import script from "./LightTheme.vue?vue&type=script&lang=js&"
export * from "./LightTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports